import { render, staticRenderFns } from "./CreateDiscountForCourse.vue?vue&type=template&id=1b4c04d6"
import script from "./CreateDiscountForCourse.vue?vue&type=script&lang=js"
export * from "./CreateDiscountForCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports